import { z } from "zod"
import { LegacyCompatibleDiscountSchema } from "../service/discount"

export const PRODUCT_QUANTITY_CONSTRAINTS = { min: 1, max: 9999 } as const

export enum PosType {
  CRONA = "CRONA",
  SPECTER = "SPECTER",
  FDT = "FDT",
  NUTID = "NUTID",
  MOREFLO = "MOREFLO",
  FORTNOX = "FORTNOX",
}

export enum ProductCatalog {
  CRONA = "CRONA",
  SPECTER = "SPECTER",
  FDT = "FDT",
  NUTID = "NUTID",
  MOREFLO = "MOREFLO",
  FORTNOX = "FORTNOX",
}

export const ProductSchema = z.object({
  id: z.string(),
  externalId: z.string().nullable().default(null),
  ean: z.string().nullable(),
  articleNumber: z.string().nullable().default(null),
  acquisitionCost: z.number().nullable().default(null),
  title: z.string(),
  price: z.number(),
  quantity: z
    .number()
    .int()
    .min(PRODUCT_QUANTITY_CONSTRAINTS.min)
    .max(PRODUCT_QUANTITY_CONSTRAINTS.max)
    .default(PRODUCT_QUANTITY_CONSTRAINTS.min),
  needsOrdering: z.boolean().default(false),
  expectedDeliveryDate: z.string().nullable().default(null),
  stock: z.number().nullable().default(null),
  discount: LegacyCompatibleDiscountSchema.nullable().optional(),
})

export type Product = z.infer<typeof ProductSchema>

export const SaveCombinedPosOrderSchema = z.object({
  jobIds: z
    .array(z.guid())
    .min(2)
    .refine((ids) => new Set(ids).size === ids.length, {
      message: "Duplicate job IDs are not allowed",
    }),
})
export type SaveCombinedPosOrder = z.infer<typeof SaveCombinedPosOrderSchema>

export const NEGLIGIBLE_LABOR_THRESHOLD_PERCENT_OPTIONS = [7, 8, 9] as const
export const NegligibleLaborThresholdPercentSchema = z.union([
  z.literal(7),
  z.literal(8),
  z.literal(9),
])
export type NegligibleLaborThresholdPercent = z.infer<
  typeof NegligibleLaborThresholdPercentSchema
>

export const UpdatePosSettingsSchema = z.object({
  markAsDeliveredOnOrderCreation: z.boolean().optional(),
  negligibleLaborThresholdPercent:
    NegligibleLaborThresholdPercentSchema.optional(),
  miscellaneousMaterialsArticleId: z.string().nullable().optional(),
  autoFinishOnPayment: z.boolean().optional(),
})
export type UpdatePosSettings = z.infer<typeof UpdatePosSettingsSchema>

export interface ProductWithoutBarcodeForJob {
  jobId: string
  id: string
  title: string
}
export interface JobAlreadyInvoiced {
  jobId: string
  posOrderId: string
}

export * from "./catalog-product"
